import React, {useEffect, useState} from 'react';
import UCustomScrollBar from 'ubs-framework/v2/UCustomScrollBar';
import UNoDataFound from 'ubs-framework/v2/UErrorPages/UNoDataFound';
import UTags from 'ubs-framework/v2/UTags';
import useUAlert from "ubs-framework/v2/UAlert";
import * as Icon from "ubs-icons";

import {sendData} from "../../../../../store/actions";
import {useSelector} from "react-redux";
import UPopup from "ubs-framework/v2/UPopup";
import InputFilter from "../../components/input-filter";
import {COLOR, LIMIT, REGEX, PROFILE_SECTION} from "ubs-framework/v2/common/constant";
import {isMobileDevice, showToastSuccess} from "ubs-framework/v2/common/function";
import {getLabelValue, getLabelValueUserImage, getObjectKey} from "ubs-framework/v2/common/function";
import useSocket from "../../../hooks/useSocket";
import useDebouncedEffect from "use-debounced-effect";
import SelectJobFilter from "../../components/select-job-filter";
import MultiSelectFilter from "../../components/multi-select-filter";
import {DUPLICATE_HANDLING} from "../../../../../common/constant";
import { useFieldLabel } from 'ubs-framework/v2/hooks/useCustomFieldConfig';


const VerifyTableData = React.memo((props) => {
    const alert = useUAlert();
    const getLabel = useFieldLabel();

    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);
    const _SL_LV = useSelector(e => getLabelValue(e?.hrms?.sourceList));
    const _ASL = useSelector(e => getLabelValue(e?.ats?.atsSkillList));
    const _DC = useSelector(e => e?.ats?.generalSetting?.duplicateCriteria);
    const _CI = useSelector(e => e?.ats?.generalSetting?.candidateIdType);
    const _TF_CL = useSelector(e => getLabelValue(e?.ats?.tagsForCandidateList));

    const [selectAll, setSelectAll] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [employeeListOption, setEmployeeListOption] = useState([]);
    const [allValues, setAllValues] = useState({
        job: null,
    })
    const [getRemark, setGetRemark] = useState(0);

    const [errorList, setErrorList] = useState(props?.uploadedFile)
    const [parseResume, setParseResume] = useState(props?.uploadedResumeForParse)

    useEffect(() => {
        sendData('ats|job|search', {})
    }, []);

    useEffect(() => {
        refresh();
        return () => off();
    }, [allValues]);

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'ats|job|search':
                    setEmployeeListOption(getLabelValueUserImage(res?.data?.list?.filter(_ => _?.applicationField?.fields)));
                    setIsLoading(false);
                    break;
                default:
                    return true;
            }
        }
    });

    useDebouncedEffect(() => {
        if (allValues?.searchEmpText?.length >= LIMIT.SEARCH_CHARACTER) sendData('ats|job|search', {listType: 4, search: allValues?.searchEmpText})
        else setEmployeeListOption([]);
    }, LIMIT.DE_BOUNCING_TIME_OUT, [allValues?.searchEmpText]);


    const searchEmployee = value => {
        setAllValues({...allValues, searchEmpText: value});
        if (value?.length) setIsLoading(true);
    }

    const handle = {
        inputChange: (e, name, index, randomId) => {
            let isContactCheck = false, isEmailCheck = false
            let validateData = {
                job: props?.selectedJob?.value,
                randomId: randomId
            }
            // const data = JSON.parse(JSON.stringify(props.uploadedResumeForParse))
            const data = props.uploadedResumeForParse

            if (e !== '') {
                data[randomId].data[name] = e
            }

            /** duplicate phone number, email in local list */
            if (e !== '' && (name === 'email' || name === 'contactNo')) {
                Object.keys(data).map((key) => {
                    if (_DC?.email) {
                        if (key !== randomId && data[key].data.email === e) {
                            data[randomId].duplicate = true
                            data[randomId].validate.isExists = true
                            isContactCheck = true
                        }
                    } else if (_DC?.phone) {
                        if (key !== randomId && data[key].data.contactNo === e) {
                            data[randomId].duplicate = true
                            data[randomId].validate.isExists = true
                            isContactCheck = true
                        }
                    } else if (_DC?.phone_and_email && data[key].data.email && data[key].data.contactNo) {
                        if (key !== randomId && data[key].data.email === data[randomId].data.email && data[key].data.contactNo === data[randomId].data.contactNo) {
                            data[randomId].duplicate = true
                            data[randomId].validate.isExists = true
                            isContactCheck = true
                        }
                    } else if (_DC?.phone_or_email) {
                        if (key !== randomId && (data[key].data.email === data[randomId].data.email || data[key].data.contactNo === data[randomId].data.contactNo)) {
                            data[randomId].duplicate = true
                            data[randomId].validate.isExists = true
                            isContactCheck = true
                        }
                    }
                })
            }
            /** duplicate phone number, email in local list */

            setErrorList(data)
            props?.FinalData(JSON.parse(JSON.stringify(data)))

            if (e !== '' && (name === 'email' || name === 'contactNo')) {
                sendData('ats|candidate|getRemark', {
                    email: data[randomId].data.email,
                    contactNo: data[randomId].data.contactNo,
                    randomId
                })
            }
            if (e !== '' && (name === 'email' || name === 'contactNo' || name === 'candidateId') && !isContactCheck) {
                if (_DC?.email) {
                    data[randomId].duplicate = false

                    validateData.email = data[randomId].data.email
                    if (data[randomId].data.candidateId) validateData.candidateId = data[randomId].data.candidateId
                    sendData('ats|candidate|validate', validateData)
                } else if (_DC?.phone) {
                    data[randomId].duplicate = false

                    validateData.contactNo = data[randomId].data.contactNo
                    if (data[randomId].data.candidateId) validateData.candidateId = data[randomId].data.candidateId
                    sendData('ats|candidate|validate', validateData)
                } else if (_DC?.phone_and_email && data[randomId].data.email && data[randomId].data.contactNo) {
                    data[randomId].duplicate = false

                    if (data[randomId].data.email) validateData.email = data[randomId].data.email
                    if (data[randomId].data.contactNo) validateData.contactNo = data[randomId].data.contactNo
                    if (data[randomId].data.candidateId) validateData.candidateId = data[randomId].data.candidateId
                    sendData('ats|candidate|validate', validateData)
                } else if (_DC?.phone_or_email) {
                    data[randomId].duplicate = false

                    if (data[randomId].data.email) validateData.email = data[randomId].data.email
                    if (data[randomId].data.contactNo) validateData.contactNo = data[randomId].data.contactNo
                    if (data[randomId].data.candidateId) validateData.candidateId = data[randomId].data.candidateId
                    sendData('ats|candidate|validate', validateData)
                } else if (name === 'candidateId') {
                    validateData.candidateId = data[randomId].data.candidateId
                    sendData('ats|candidate|validate', validateData)
                }
            }
        },
        select: (e, key) => {
            if (key === 'job') {
                if (e?._id) {
                    sendData('ats|job|fetch', {_id: e?._id})
                }
            }
            setAllValues({...allValues, [key]: e ?? null})

        },
        selectChange: (e, name, index, randomId) => {
            const data = props.uploadedResumeForParse
            if (e !== null) {
                delete e.applicationField
                data[randomId].data[name] = e
            }
            if (e?._id) {
                let validateData = {
                    job: e?._id,
                    randomId: randomId,
                    email: data[randomId].data.email,
                    contactNo: data[randomId].data.contactNo
                }
                sendData('ats|candidate|validate', validateData)
            }
            setErrorList(data)
            props?.FinalData(JSON.parse(JSON.stringify(data)))
        },
        replaceData: (randomId) => {
            const data = props.uploadedResumeForParse
            data[randomId].data.isReplace = true
            data[randomId].validate.isExists = false
            data[randomId].data._id = data[randomId]?.validate?.candidate?._id
            setErrorList(data)
            props?.FinalData(JSON.parse(JSON.stringify(data)))
            showToastSuccess('Data Replaced Successfully.')
        },
        removeData: (randomId) => {
            alert.show({
                title: `Delete Data`,
                icon: <span className="u_icon u_red-bgicon u_m-auto"><Icon.Delete fill={COLOR.u_red} size={30}/></span>,
                description: `Are you sure you want to Remove Data?`,
                submit: 'Yes',
                onSubmit: () => {
                    const data = props.uploadedResumeForParse
                    delete data[randomId]
                    setErrorList(JSON.parse(JSON.stringify(data)))
                    props?.FinalData(JSON.parse(JSON.stringify(data)))
                    props?.setGlobalErrorList(JSON.parse(JSON.stringify(data)))
                }
            });
        },

        selectAll: (e) => {
            setSelectAll(e.target.checked)
            Object.keys(errorList).forEach((ele) => {
                errorList[ele].isSelected = e.target.checked;
            });

            props?.setIsMulti(Object.values(errorList).filter(_ => _?.isSelected));
            setErrorList(JSON.parse(JSON.stringify(errorList)))
        },

        selectCheckbox: (e, randomId) => {
            Object.keys(errorList).forEach((ele) => {
                if (ele === randomId) {
                    errorList[ele].isSelected = e.target.checked;
                }
            });
            props?.setIsMulti(Object.values(errorList).filter(_ => _?.isSelected));
            setErrorList(JSON.parse(JSON.stringify(errorList)))
        },
        openRemark: (data) => {
            props?.setGetRemark({
                email: data?.email,
                contactNo: data?.contactNo
            })
        }
    }

    useEffect(() => {
        /** for update ERROR data */
        setErrorList(props?.uploadedFile)
        props?.FinalData(props?.uploadedFile)
        // props.uploadedResumeForParse(props?.uploadedFile)
    }, [props?.uploadedFile])

    return (
        <React.Fragment>
            <div className="u_p-10 u_flex-align">
                <p className="u_color-title u_small-font u_flex-1">{Object.keys(errorList)?.length || 0} Resume</p>
                {_DC?.isDuplicateEnabled && <p className="u_small-font">Duplicate Criteria: <br/><span className="u_color-title u_text-c"
                                                                           dangerouslySetInnerHTML={{__html: DUPLICATE_HANDLING[getObjectKey(_DC, true)]}}/></p>}
            </div>
            <UCustomScrollBar className="u_import-scroll">
                <div className="u_table-resource u_table-resource-nowrap u_table-resource-hover u_table-resource-no-sticky u_text-left">
                    <table>
                        <thead className="u_table-resource-header">
                        <tr>
                            {/*<th>
                                <UCheckBox
                                    id="checkbox_checked"
                                    label=""
                                    checked={selectAll}
                                    onChange={(e) => handle.selectAll(e)}
                                />
                            </th>*/}
                            <th>Sr. No.</th>
                            {(_CI === 1 || !_CI)  && props?.selectedJob?.candidateIdStatus !== 3 && <th>{getLabel(PROFILE_SECTION.basicInfo, 'candidateId', 'Candidate ID')}</th>}
                            <th>View Resume</th>
                            <th>RandomId</th>
                            <th>File Name</th>
                            <th>Status</th>
                            <th>Job</th>
                            <th>{getLabel(PROFILE_SECTION.basicInfo, 'firstName', 'First Name')}</th>
                            <th>{getLabel(PROFILE_SECTION.basicInfo, 'lastName', 'Last Name')}</th>
                            <th>{getLabel(PROFILE_SECTION.emergencyContact, 'email', 'Email')} Address</th>
                            <th>Contact Number</th>
                            <th>Remarks</th>
                            <th>Skills</th>
                            <th>Tags</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {Object.keys(errorList)?.map((randomId, i) => {
                            return (
                                <tr key={randomId} className={`${props.uploadedResumeForParse[randomId]?.url ? '' : 'u_btn-disabled'}`}>
                                    {/*<td className={`${props?.parsedResumeData.find(_ => _.rcandomId === randomId) ? 'u_btn-disabled' : ''}`} style={{backgroundColor: '#fff'}}>
                                        <UCheckBox
                                            id={randomId}
                                            label={' '}
                                            checked={props?.parsedResumeData.find(_ => _.randomId === randomId) ? false : errorList[randomId]?.isSelected}
                                            onChange={(e) => handle.selectCheckbox(e, randomId)}
                                            disabled={props?.parsedResumeData.find(_ => _.randomId === randomId) || false}
                                        />
                                    </td>*/}
                                    <td style={{backgroundColor: '#fff'}}>{i + 1}</td>

                                    {(_CI === 1 || !_CI) && props?.selectedJob?.candidateIdStatus !== 3 && <td className={`${props?.parsedResumeData.find(_ => _.randomId === randomId) ? 'u_btn-disabled' : ''}`}
                                        style={{backgroundColor: props.uploadedResumeForParse[randomId]?.data?.['candidateId'] ? '#fff' : props?.selectedJob?.candidateIdStatus === 1 ? '#ffe9e7' : props.uploadedResumeForParse[randomId]?.validate?.isCandidateIdExists ? '#ffe9e7' : '#fff'}}
                                    >
                                        <InputFilter
                                            name="candidateId"
                                            placeholder={`Enter ${getLabel(PROFILE_SECTION.basicInfo, 'candidateId', 'Candidate ID')}`}
                                            onChange={(e) => handle.inputChange(e?.toUpperCase(), 'candidateId', i, randomId)}
                                            errorTitle={props.uploadedResumeForParse[randomId]?.data?.['candidateId'] || randomId?.['candidateId']}
                                        />
                                    </td>}

                                    <td style={{backgroundColor: '#fff'}}>
                                        <a href={_S3_BASE_URL + props.uploadedResumeForParse[randomId]?.url}
                                           className={`u_lh-0 ${props.uploadedResumeForParse[randomId]?.url ? '' : 'u_btn-disabled'}`} target="_blank" rel="noopener noreferrer"
                                           download>
                                            <Icon.Eye fill={COLOR.u_blue} size={16}/>
                                        </a>
                                    </td>
                                    <td style={{backgroundColor: '#fff'}}>{randomId || '-'}</td>
                                    <td className={`${props?.parsedResumeData.find(_ => _.randomId === randomId) ? 'u_btn-disabled' : ''}`}
                                        style={{backgroundColor: '#fff'}}>{errorList[randomId]?.name || errorList[randomId]?.fileName || '-'}</td>

                                    <td className={`${props?.parsedResumeData.find(_ => _.randomId === randomId) ? 'u_btn-disabled' : ''}`} style={{backgroundColor: '#fff'}}>{
                                        props.uploadedResumeForParse[randomId]?.data?.isReplace ? <UTags className="u_ib" title="Replace" color={COLOR.u_orange}/> :
                                            props.uploadedResumeForParse[randomId]?.validate?.isExists || props.uploadedResumeForParse[randomId]?.validate?.isCandidateIdExists ? <UTags className="u_ib" title="Duplicate" color={COLOR.u_pastelred}/> :
                                                props?.parsedResumeData.find(_ => _.randomId === randomId) ? <UTags className="u_ib" title="Uploaded" color={COLOR.u_blue}/> :
                                                    props.uploadedResumeForParse[randomId]?.data ? <UTags className="u_ib" title="Completed" color={COLOR.u_green}/> :
                                                        props.uploadedResumeForParse[randomId] ? <UTags className="u_ib" title="Parsing" color={COLOR.u_purple}/> :
                                                            <UTags className="u_ib" title="Pending" color={COLOR.u_orange}/>
                                    }</td>

                                    <td className={`u_job-disabled ${props?.parsedResumeData.find(_ => _.randomId === randomId) ? 'u_btn-disabled' : ''}`} style={{backgroundColor: '#fff'}}>
                                        <SelectJobFilter
                                            placeholder="Select Job"
                                            errorTitle={props.uploadedResumeForParse[randomId]?.data?.job || props?.selectedJob || null}
                                            iconType="job"
                                            type="job"
                                            onChange={(e) => handle.selectChange(e, 'job', i, randomId)}

                                            isLoading={isLoading}
                                            option={employeeListOption}
                                            onInputChange={searchEmployee}
                                        />
                                    </td>

                                    <td className={`${props?.parsedResumeData.find(_ => _.randomId === randomId) ? 'u_btn-disabled' : ''}`}
                                        style={{backgroundColor: props.uploadedResumeForParse[randomId]?.data?.['firstName'] ? '#fff' : '#ffe9e7'}}
                                    >
                                        <InputFilter
                                            name="firstName"
                                            placeholder={`Enter ${getLabel(PROFILE_SECTION.basicInfo, 'firstName', 'First Name')}`}
                                            onChange={(e) => handle.inputChange(e, 'firstName', i, randomId)}
                                            errorTitle={props.uploadedResumeForParse[randomId]?.data?.['firstName'] || randomId?.['firstName']}
                                        />
                                    </td>

                                    <td className={`${props?.parsedResumeData.find(_ => _.randomId === randomId) ? 'u_btn-disabled' : ''}`} style={{backgroundColor: '#fff'}}>
                                        <InputFilter
                                            name="lastName"
                                            placeholder={`Enter ${getLabel(PROFILE_SECTION.basicInfo, 'lastName', 'Last Name')}`}
                                            onChange={(e) => handle.inputChange(e, 'lastName', i, randomId)}
                                            errorTitle={props.uploadedResumeForParse[randomId]?.data?.['lastName'] || randomId?.['lastName']}
                                        />
                                    </td>

                                    <td className={`${props?.parsedResumeData.find(_ => _.randomId === randomId) ? 'u_btn-disabled' : ''}`}
                                        style={{
                                            backgroundColor: (props.uploadedResumeForParse[randomId]?.data?.['email'] &&
                                                REGEX.EMAIL.test(props.uploadedResumeForParse[randomId]?.data?.['email']) &&
                                                ((_DC?.email || _DC?.phone_or_email || _DC?.phone_and_email) ? props.uploadedResumeForParse[randomId]?.emailErr === '' : true)) ? '#fff' : '#ffe9e7'
                                        }}>
                                        <InputFilter
                                            name="email"
                                            placeholder={`Enter ${getLabel(PROFILE_SECTION.emergencyContact, 'email', 'Email')} Address`}
                                            onChange={(e) => handle.inputChange(e, 'email', i, randomId)}
                                            errorTitle={props.uploadedResumeForParse[randomId]?.data?.['email'] || errorList[randomId]?.data?.['email']}
                                        />
                                    </td>

                                    <td className={`${props?.parsedResumeData.find(_ => _.randomId === randomId) ? 'u_btn-disabled' : ''}`}
                                        style={{backgroundColor: ((_DC?.phone || _DC?.phone_or_email || _DC?.phone_and_email) ? props.uploadedResumeForParse[randomId]?.contactNoErr === '' : true) ? '#fff' : '#ffe9e7'}}>
                                        <InputFilter
                                            name="contactNo"
                                            placeholder="Enter Contact Number"
                                            onChange={(e) => handle.inputChange(e, 'contactNo', i, randomId)}
                                            errorTitle={props.uploadedResumeForParse[randomId]?.data?.['contactNo'] || randomId?.['contactNo']}
                                        />
                                    </td>
                                    <td className="u_remarks u_flex-align">
                                        {props?.uploadedResumeForParse[randomId]?.data?.remarkCount ? <><span className="u_ib">
                                            <UTags
                                                className="u_flex-align u_flex-row-reverse"
                                                icon={<Icon.UserStar size={16} fill={COLOR.u_purple}/>}
                                                title={`This candidate received ${props?.uploadedResumeForParse[randomId]?.data?.remarkCount} Remarks` || 0}
                                                color={COLOR.u_purple}
                                                length={1500}
                                            />
                                        </span>
                                        <p className="u_remarks-view u_color-blue u_ml-5 u_small-font u_flex-align" onClick={() => handle.openRemark(props.uploadedResumeForParse[randomId]?.data)}>View Remarks<span className="u_ml-5"><Icon.ArrowLeftLine size={16} fill={COLOR.u_blue}/></span></p>
                                        </> : '-'}
                                    </td>

                                    <td className={`${props?.parsedResumeData.find(_ => _.randomId === randomId) ? 'u_btn-disabled' : ''}`} style={{backgroundColor: '#fff'}}>
                                        <MultiSelectFilter
                                            placeholder="Select Skill"
                                            option={_ASL}
                                            errorTitle={props.uploadedResumeForParse[randomId]?.data?.skill || errorList[randomId]?.data?.['skill']}
                                            iconType="skill"
                                            type="skill"
                                            onChange={(e) => handle.selectChange(e, 'skill', i, randomId)}
                                        />
                                    </td>

                                    <td className={`${props?.parsedResumeData.find(_ => _.randomId === randomId) ? 'u_btn-disabled' : ''}`} style={{backgroundColor: '#fff'}}>
                                        <MultiSelectFilter
                                            placeholder="Select Tag"
                                            option={_TF_CL}
                                            errorTitle={props.uploadedResumeForParse[randomId]?.data?.tags || errorList[randomId]?.data?.['tags']}
                                            iconType="tags"
                                            type="tags"
                                            onChange={(e) => handle.selectChange(e, 'tags', i, randomId)}
                                        />
                                    </td>

                                    <td className={`${props?.parsedResumeData.find(_ => _.randomId === randomId) ? 'u_btn-disabled' : ''}`} style={{backgroundColor: '#fff'}}>
                                        <div className="u_flex u_align-center">
                                            {
                                                props.uploadedResumeForParse[randomId]?.duplicate ? <UPopup
                                                    params={{className: "u_tooltip", disabled: isMobileDevice()}}
                                                    desc={
                                                        <span>Delete Data</span>}
                                                >
                                                    <span className="u_icon-rollover u_cp u_ml-5" onClick={() => handle.removeData(randomId)}>
                                                        <Icon.Delete fill={COLOR.u_blue} size={16}/>
                                                    </span>
                                                </UPopup> : <React.Fragment>
                                                    {!props.uploadedResumeForParse[randomId]?.data?.isReplace && props.uploadedResumeForParse[randomId]?.validate?.isExists &&
                                                    <UPopup
                                                        params={{className: "u_tooltip", disabled: isMobileDevice()}}
                                                        desc={<span>Replace Data</span>}
                                                    >
                                                        <span className="u_icon-rollover u_cp" onClick={() => handle.replaceData(randomId)}>
                                                            <Icon.CheckMark fill={COLOR.u_blue} size={16}/>
                                                        </span>
                                                    </UPopup>}

                                                    <UPopup
                                                        params={{className: "u_tooltip", disabled: isMobileDevice()}}
                                                        desc={
                                                            <span>{`${!props.uploadedResumeForParse[randomId]?.data?.isReplace && props.uploadedResumeForParse[randomId]?.validate?.isExists ? 'Ignore Data' : 'Delete Data'}`}</span>}
                                                    >
                                                        <span className="u_icon-rollover u_cp u_ml-5" onClick={() => handle.removeData(randomId)}>
                                                            {
                                                                !props.uploadedResumeForParse[randomId]?.data?.isReplace && props.uploadedResumeForParse[randomId]?.validate?.isExists ?
                                                                    <Icon.Close fill={COLOR.u_blue} size={16}/> :
                                                                    <Icon.Delete fill={COLOR.u_blue} size={16}/>
                                                            }
                                                        </span>
                                                    </UPopup>
                                                </React.Fragment>
                                            }
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                    {errorList?.length === 0 && <UNoDataFound width={300} image="/images/no-data-found.svg" message="No data to display"/>}
                </div>
            </UCustomScrollBar>
        </React.Fragment>
    );
});

export default VerifyTableData;
